import React from "react";
import Styles from './styles.module.scss';
import CustomBorder from "../_UI/customBorder";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

const PreSaleS3 = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.nameWrap}`}>
                    <h2>{t('Почему стоит присоединиться к пресейлу?')}</h2>
                    <p>{t('Забронируйте свою аллокацию токенов Time Capsule ($TC) до публичного запуска. Участники пресейла получают раннюю позицию и приоритетный доступ внутри экосистемы.')}</p>
                    <div className={`${Styles.btnWrap}`}>
                        <CustomBorder corners={{ topRight: true, bottomLeft: true }}  withHover={true} fill="#261f1a" borderColor="#FFD700">
                            <button className={`${Styles.btn}`} onClick={()=>{navigate('/sign-in')}}><div>{t('Купить токены')}</div></button>
                        </CustomBorder>
                    </div>
                </div>
                <div className={`${Styles.valueWrap}`}>
                    <div className={`${Styles.valueBox}`}>
                        <div className={Styles.timeline}>
                            <div className={Styles.timelineItem}>
                                <div className={Styles.num}>01</div>
                                <div className={Styles.timelineItemTextWrap}>
                                    <div className={Styles.timelineItemTextTitle}>{t('Ранний вход')}</div>
                                    <div className={Styles.timelineItemText}>{t('Войдите до публичного запуска и получите лучшие условия.')}</div>
                                </div>
                            </div>
                            <div className={Styles.timelineItem}>
                                <div className={Styles.num}>02</div>
                                <div className={Styles.timelineItemTextWrap}>
                                    <div className={Styles.timelineItemTextTitle}>{t('Лимитированная аллокация')}</div>
                                    <div className={Styles.timelineItemText}>{t('В этом раунде доступно только фиксированное количество токенов.')}</div>
                                </div>
                            </div>
                            <div className={Styles.timelineItem}>
                                <div className={Styles.num}>03</div>
                                <div className={Styles.timelineItemTextWrap}>
                                    <div className={Styles.timelineItemTextTitle}>{t('Рост цены')}</div>
                                    <div className={Styles.timelineItemText}>{t('Каждый следующий этап проходит по более высокой цене.')}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
export default PreSaleS3;

